import React from 'react';
import { InputAdornment, TextField, Typography, type TextFieldProps } from '@mui/material';
import {
  getFoundObjectReferencePrefix,
  sanitizeReferenceSuffixInput,
} from '../utils/foundObjectReference';

type ReferenceSuffixFilterFieldProps = {
  value: string;
  onChange: (suffix: string) => void;
  providerId?: number;
} & Pick<TextFieldProps, 'fullWidth' | 'size' | 'sx'>;

/**
 * Recherche par numéro d'étiquette : saisie du chiffre après le tiret uniquement.
 */
const ReferenceSuffixFilterField: React.FC<ReferenceSuffixFilterFieldProps> = ({
  value,
  onChange,
  providerId,
  fullWidth = true,
  size = 'small',
  sx,
}) => {
  const prefix = providerId ? getFoundObjectReferencePrefix(providerId) : 'T…-';

  return (
    <TextField
      fullWidth={fullWidth}
      size={size}
      label="N° étiquette"
      placeholder="Ex. 2"
      value={value}
      onChange={(e) => onChange(sanitizeReferenceSuffixInput(e.target.value))}
      inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Typography
              component="span"
              variant="body2"
              sx={{ fontWeight: 600, color: 'text.secondary', whiteSpace: 'nowrap' }}
            >
              {prefix}
            </Typography>
          </InputAdornment>
        ),
      }}
      sx={sx}
    />
  );
};

export default ReferenceSuffixFilterField;
